import { useTranslation } from 'react-i18next';

interface CourierStatusCardProps {
  isOnline: boolean;
  onToggle: () => void;
  vehicleType: 'bike' | 'scooter' | 'car';
}

export default function CourierStatusCard({ isOnline, onToggle, vehicleType }: CourierStatusCardProps) {
  const { t } = useTranslation();
  
  const vehicleIcons = {
    bike: '🚲',
    scooter: '🛵',
    car: '🚗',
  };
  
  return (
    <div className="bg-white rounded-2xl p-5 shadow-md">
      <div className="flex items-center justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <div className={`w-3 h-3 rounded-full ${isOnline ? 'bg-green-500' : 'bg-gray-400'} ${isOnline ? 'animate-pulse' : ''}`}></div>
            <p className="text-base font-bold text-gray-900">
              {isOnline ? t('online') : t('offline')}
            </p>
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">
            {isOnline ? t('availableForDeliveries') : t('notReceivingOrdersNow')}
          </p>
          <p className="text-xs text-gray-500 mt-1">
            {isOnline ? t('youWillReceiveNearbyOrders') : t('goOnlineToStartEarning')}
          </p>
        </div>
        
        <button
          onClick={onToggle}
          className="relative w-16 h-9 rounded-full transition-all flex-shrink-0"
          style={{ backgroundColor: isOnline ? '#10B981' : '#D1D5DB' }}
        >
          <div
            className={`absolute top-1 w-7 h-7 bg-white rounded-full shadow-md transition-transform ${
              isOnline ? 'translate-x-8' : 'translate-x-1'
            }`}
          ></div>
        </button>
      </div>
      
      <div className="flex items-center gap-2 pt-3 border-t border-gray-100">
        <div className="flex items-center justify-center w-8 h-8 bg-blue-50 rounded-lg text-lg">
          {vehicleIcons[vehicleType]}
        </div>
        <span className="text-sm font-semibold text-gray-700">
          {t(vehicleType)}
        </span>
      </div>
    </div>
  );
}
